(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('InsumoDialogController', InsumoDialogController);

    InsumoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Insumo', 'Localarmazenamento', 'Alocacaoinsumos', 'Aquisicao'];

    function InsumoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Insumo, Localarmazenamento, Alocacaoinsumos, Aquisicao) {
        var vm = this;

        vm.insumo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.localarmazenamentos = Localarmazenamento.query();
        vm.alocacaoinsumos = Alocacaoinsumos.query();
        vm.aquisicaos = Aquisicao.query();
        vm.restante = vm.insumo.quantidadearmazenada;
        vm.mudaMax = mudaMax;

        vm.insumo.aquisicao = new Aquisicao();

        Aquisicao.get({id: vm.insumo.aquisicao.id}).$promise.then(function(data){
            vm.restante = data.quantidade;
            Insumo.query().$promise.then(function(data2){
                var i = 0;
                for(i=0; i<data2.length; i++){
                    if(data2[i].id !== vm.insumo.id){
                        if(data2[i].aquisicao.id === vm.insumo.aquisicao.id){
                            vm.restante = vm.restante - data2[i].quantidadearmazenada;
                        }
                    }
                }
            });
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insumo.id !== null) {
                Insumo.update(vm.insumo, onSaveSuccess, onSaveError);
            } else {
                Insumo.save(vm.insumo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:insumoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataentrada = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function mudaMax(){
            vm.maxarmazenado = vm.insumo.quantidadearmazenada;
        }
    }
})();
